import { createAsyncThunk } from '@reduxjs/toolkit';
import superagent from '@ott/superagent';
import checkAjaxError from '@ott/helper-check-ajax-error';
import { actions as creditCardsActions } from '@ott/shared-credit-cards-logic';
import { actions as virtualCardActions } from '@ott/shared-virtual-card-logic';

import { regReset } from '../regReset';

import { AuthError, SuperagentError } from '../../types';
import { Payload } from './types';

export const exit = createAsyncThunk<void, Payload, { rejectValue: AuthError }>(
  'auth/exit/fetch',
  async (args, { dispatch, rejectWithValue }) => {
    const { reqHost = '' } = args ?? {};

    const url = `${reqHost}/_auth/authenticate/exit`;
    try {
      const { body } = await superagent.post(url).withCredentials();

      if (body && body?.error) {
        return rejectWithValue({ data: body.error });
      }

      dispatch(creditCardsActions.clearCardList());
      dispatch(virtualCardActions.resetCardInfo());
      dispatch(regReset());
    } catch (e) {
      const err = e as SuperagentError;
      if ('response' in err) {
        return rejectWithValue({ data: checkAjaxError(err), status: err?.status });
      }
    }
  }
);
